import type { SnippetsProvider } from '@atlassian/editor-snippets-provider/types';

import { getSnippetsStateSnapshot, onCurrentFetchComplete } from '../store/snippetsStore.ts';

import { mapConfluenceSnippet } from './mapConfluenceSnippet.ts';

export const confluenceSnippetsProvider: SnippetsProvider = {
	getSnippets: () => {
		const { snippets, isLoaded, fetchError } = getSnippetsStateSnapshot();

		if (isLoaded) {
			return Promise.resolve(snippets.map(mapConfluenceSnippet));
		}

		if (fetchError) {
			return Promise.resolve([]);
		}

		return new Promise((resolve) => {
			onCurrentFetchComplete((loadedSnippets) => {
				resolve(loadedSnippets.map(mapConfluenceSnippet));
			});
		});
	},
};
